<template>
  <section class="py-4">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <div class="text-center">
            <h3 class="text-h4 font-weight-light mb-3">
              Boost your Reputation
            </h3>
            <h4 class="text-body-1 mb-6">
              A suite of amazing features helps you explore the professional
              you.<br />
              Be a part of the Pro community and enjoy extra reputation points.
            </h4>
            <div class="text-center">
              <v-btn
                to="/membership"
                depressed
                x-large
                dark
                nuxt
                class="h-60 ma-0 mt-6"
              >
                Get Pro
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'ReputationPro'
}
</script>
